<template>
  <div class="card-206 col-12">
    <div class="p-4 row align-content-center justify-content-center">
      <div class="text-center">
        <m-img class="mb-2 card-206-image" :src="content.thumbnail" :alt="content.title"/>
      </div>
    </div>
  </div>
</template>

<script>
import mCard206 from "../../Cards/Card206";
import mImg from '../../Tags/Img'

export default {
  name: "ContentCard206",
  components: {mCard206, mImg},
  props: {
    content: {}
  },
}
</script>

<style scoped>
.card-206-image {
  object-fit: contain;
  height: 95px;
  width: 95px;
}

</style>